<template>
  <ul-page class="page-virtual-classList" contentWidthFixed>
    <template v-slot:left>
      <div class="page-header-left">
        <span class="icon"><i class="iconfont icon-xunifangzhen_tianchong"></i></span>
        <span class="text">AI实验</span>
      </div>
    </template>
    <div class="tabs">
      <div class="tab-item" :class="{'active': params.type == 1}" @click="typeChange(1)">虚拟仿真实验</div>
      <div class="tab-item" :class="{'active': params.type == 2}" @click="typeChange(2)">AI实训实验</div>
    </div>
    <div class="page-content">
      <div class="filters">
        <ul-select class="select-type" v-model="params.typeId" @change="getFirstPage">
          <ul-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </ul-option>
        </ul-select>
        <ul-input
          class="input-search"
          v-model="params.keyword"
          clearable
          suffix-icon="icon-quanshipei-sousuo"
          @keydown.native.enter="getFirstPage"
          search
          @clear="getFirstPage"
          @search="getFirstPage"
          placeholder="输入关键字搜索"
        ></ul-input>
        <ul-button type="primary" class="button-right" @click="creationBtu()">
          {{params.type == 1 ? '创建虚仿课程' : '创建AI实训课程'}}
        </ul-button>
      </div>
      <div class="course-list" v-if="courseList.length > 0">
        <div
          class="course-item"
          v-for="item in courseList"
          :key="item.id"
        >
          <div class="course-item-left">
            <img @click="goPage(item)" :src="item.cover || homePage">
            <div class="item-info">
              <div class="name" @click="goPage(item)" :class="item.publishState == 1 ? '' : 'not-issue-name'">{{ item.name }}</div>
              <div class="tea">
                <i class="iconfont icon-jigouzhanghao"></i>
                负责教师：{{ item.teacher ? item.teacher : '--' }}
              </div>
              <div class="tag" :class="item.publishState == 1 ? 'tag-publish' : 'not-issue'">
                {{ item.publishState == 1 ? '已发布' : '未发布' }}
              </div>
            </div>
          </div>
          <div class="course-item-right">
            <ul-dropdown
              @command="handleCommand($event, item)"
            >
              <ul-button class="ul-dropdown-link" size="small" hollow>
                <span class="button-text">查看课程</span>
                <i class="iconfont icon-xialacaozuo"></i>
              </ul-button>
              <ul-dropdown-menu slot="dropdown" class="export-menu">
                <ul-dropdown-item command="f">查看课程</ul-dropdown-item>
                <ul-dropdown-item command="a">课程主页</ul-dropdown-item>
                <ul-dropdown-item command="b" v-if="item.publishState == 0">发布课程</ul-dropdown-item>
                <ul-dropdown-item command="c" v-if="item.publishState == 0">删除课程 </ul-dropdown-item>
                <!-- <ul-dropdown-item command="d" v-if="item.publishState == 1">更新课程</ul-dropdown-item> -->
                <ul-dropdown-item command="e" v-if="item.publishState == 1">撤回课程</ul-dropdown-item>
              </ul-dropdown-menu>
            </ul-dropdown>
          </div>
        </div>
      </div>
      <div v-else class="empty">
        <img :src="empty">
        暂无课程
      </div>
      <ul-pagination
        hide-on-single-page
        class="pagination"
        layout="prev, pager, next, jumper"
        :total="totalNum"
        :page-size.sync="params.ps"
        :current-page.sync="params.pn"
        @current-change="getCourseList"
      ></ul-pagination>
    </div>
    <ul-dialog
      width="420px"
      title="创建课程"
      class="creation-experiment"
      :visible.sync="dialogVisible"
    >
      <ul-form ref="experimentForm" :model="form" :rules="rules">
        <ul-form-item prop="name">
          <ul-input
            v-model="form.name"
            placeholder="请输入课程名称"
            type="text"
          />
        </ul-form-item>
      </ul-form>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="submitExperiment">确定</ul-button>
        <ul-button plain @click="dialogVisible = false">取消</ul-button>
      </span>
    </ul-dialog>
  </ul-page>
</template>

<script>
import {
  createVirtualCourse,
  getCourseList,
  publishVirtualCourse,
  revokeVirtualCourse,
  deleteVirtualCourse,
  updateVirtualCourse,
  getUserRoot
} from '@/api/courseApi/virtual.js'
import homePage from '@/assets/images/virtual/homePage.png'
import empty from '@/assets/images/empty1.png'
export default {
  name: 'page-virtual-classList',
  data() {
    return {
      homePage,empty,
      dialogVisible: false,
      form: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入课程名称', trigger:"blur" },
          { max: 50, message: '虚仿课程名称最多50字', trigger: 'blur'},
        ],
      },
      typeList: [
        {id: '', name: '全部状态'},
        {id: 1, name: '已发布'},
        {id: 0, name: '未发布'},
      ],
      params: {
        typeId: '',
        keyword: '',
        pn: 1,
        ps: 20,
        type: 1
      },
      totalNum: 0,
      courseList: []
    }
  },
  created() {
    this.getCourseList()
  },
  methods: {
    goPage(item) {
      this.$router.push({path: '/virtual/homePage/' + item.id + '/experimentalRes'})
    },
    creationBtu() {
      getUserRoot()
      .then(({result})=>{
        if(result) {
          this.dialogVisible = true
          this.form = { name: '' }
          this.$nextTick(()=>{
            this.$refs.experimentForm.clearValidate()
          })
        } else {
          this.$confirm('您的账号暂未开通虚拟仿真实验相关权限，请联系线上客服或拨打电话客服电话400 610 7808咨询开通。','提示', {
            confirmButtonText: '我知道了',
            showCancelButton: false,
          })
          .then(()=>{

          })
        }
      })
    },
    handleCommand(e, item) {
      switch (e) {
        case 'a':
          window.open(`#/virtual/coursePage/${item.id}`)
          break;
        case 'b':
          this.publishCourses(item)
          break;
        case 'c':
          this.delCourse(item)
          break;
        case 'd':
          this.updateCourse(item)
          break;
        case 'e':
          this.revocation(item)
          break;
        case 'f':
          this.goPage(item)
          break;
        default:
          break;
      }
    },
    publishCourses(item) {
      this.$confirm('发布课程后，教师可以在班课中引用实验资源，确定发布吗？','发布课程')
      .then(()=>{
        publishVirtualCourse(item.id)
        .then(()=>{
          this.$message({
            message: '发布成功',
            type: 'success'
          })
          this.getCourseList()
        })
      })
    },
    delCourse(item) {
      this.$confirm('确定删除课程吗？','删除课程')
      .then(()=>{
        deleteVirtualCourse(item.id)
        .then((res)=>{
          this.getCourseList()
        })
        .catch(err => {
          this.$message({
            message: `${item.name}虚仿课程中实验资源已被班课引用，无法删除。`,
            type: 'error'
          })
        })
      })
    },
    updateCourse(item) {
      updateVirtualCourse(item.id)
      .then(()=>{
        this.$message({
          message: '更新成功',
          type: 'success'
        })
      })
    },
    revocation(item) {
      this.$confirm('课程撤回后，未引用实验的班课将不能使用实验资源，已引用的班课不受影响，确定撤回课程吗？','撤回课程')
      .then(()=>{
        revokeVirtualCourse(item.id)
        .then(()=>{
          this.getCourseList()
        })
      })
    },
    submitExperiment() {
      this.$refs.experimentForm.validate((valid)=>{
        if (valid) {
          let data = {
            name: this.form.name,
            type: this.params.type
          }
          createVirtualCourse(data)
          .then(res => {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.goPage({id: res.result})
          })
        }
      })
    },
    getFirstPage() {
      this.params.pn = 1
      this.getCourseList()
    },
    getCourseList() {
      let data = {
        courseName: this.params.keyword,
        pn: this.params.pn,
        ps: this.params.ps,
        type: this.params.type,
        publishState: this.params.typeId
      }
      getCourseList(data)
      .then((res)=>{
        this.courseList = res.list
        this.totalNum = res.total
      })
    },
    typeChange (val) {
      this.params.type = val
      this.getFirstPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header-left {
  display: flex;
  font-size: 18px;
  font-weight: 600;
  align-items: center;
  .icon {
    margin-right: 8px;
    font-weight: normal;
    color: #fff;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: linear-gradient(180deg, #FF8887 0%, #FF4E4E 100%);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 12px;
    }
  }
  .text {
    line-height: 18px;
  }
}
.tabs {
  display: flex;
  background-color: $--background-color-base;
  color: $--color-text-secondary;
  margin-top: 24px;
  .tab-item {
    margin-right: 10px;
    padding: 13px 26px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
    cursor: pointer;
    &.active {
      color: $--color-primary;
    }
  }
}
.page-content {
  padding: 20px 30px 40px;
  .filters {
    .ul-select{
      margin-right: 10px;
    }
    .select-type{
      width: 150px;
    }
    .input-search{
      width: 210px;
    }
    .button-right {
      float: right;
    }
  }
  .course-list {
    margin-top: 24px;
    .course-item {
      padding: 22px 0;
      border-bottom: 1px dashed #E3E3E9;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }
      .course-item-left {
        display: flex;
        img {
          border-radius: 4px;
          width: 160px;
          height: 90px;
          display: block;
          margin-right: 16px;
          cursor: pointer;
        }
        .item-info {
          .name {
            cursor: pointer;
            overflow-wrap: break-word;
            @include ellipsis;
            margin-bottom: 10px;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.5;
            &.not-issue-name {
              color: #969696;
            }
            &:hover {
              color: #8D77FB;
            }
          }
          .tea {
            color: #969696;
            font-size: 14px;
            margin-bottom: 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            padding-right: 16px;
            i {
              font-size: 14px;
              margin-right: 4px;
              color: #cbcbd1;
            }
          }
          .tag {
            display: inline-block;
            font-size: 12px;
            width: 44px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            &.tag-publish {
              color: #69D184;
              border-radius: 2px;
              border: 1px solid #69D184;
              background: rgba(105, 209, 132, 0.10);
            }
            &.not-issue {
              color: #F7B13D;
              border-radius: 2px;
              border: 1px solid #F7B13D;
              background: rgba(247, 177, 61, 0.10);
            }
          }
        }
      }
      .course-item-right {
        .ul-dropdown-link {
          padding: 6px 10px;
          .button-text {
            // margin-right: 6px;
            line-height: 18px;
            display: inline-block;
            text-align: left;
          }
          .icon-xialacaozuo {
            font-size: 12px;
            transform: scale(0.7);
            display: inline-block;
          }
        }
      }
    }
  }
  .empty {
    display: flex;
    align-items: center;
    flex-direction: column;
    img {
      width: 190px;
      margin-bottom: 16px;
    }
    text-align: center;
    margin: 270px auto;
    color: #969696;
  }
}
.pagination {
  display: flex;
  margin-top: 14px;
  justify-content: center
}
::v-deep.creation-experiment {
  .ul-dialog__body {
    height: 125px;
  }
}
.export-menu {
  width: 96px;
}
</style>